import type { LanguageResource } from "@ruter-as/web-components-and-tools";

interface LoadingLanguageResource {
	loading: string;
}

const loadingLanguageResource: LanguageResource<LoadingLanguageResource> = {
	nb: {
		loading: "Laster...",
	},
};

export default loadingLanguageResource;
